import routeGenerator, { ApiRouteGenerator } from '@/api/ApiRouteGenerator'
import snakeCase from 'lodash/snakeCase'

type Parameters = { [key: string]: any }

export abstract class AbstractApi {
  protected apiModelName: string
  protected routeGenerator: ApiRouteGenerator

  constructor(apiModelName: string) {
    this.apiModelName = snakeCase(apiModelName)
    this.routeGenerator = routeGenerator
  }

  public generateAdminRoute(parameters?: Parameters, customModelName?: string) {
    const modelName = customModelName || this.apiModelName
    return this.routeGenerator.generateAdminRoute(`${modelName}`, parameters)
  }

  public generateRoute(parameters?: Parameters, customModelName?: string) {
    const modelName = customModelName || this.apiModelName
    return this.routeGenerator.generateRoute(`${modelName}`, parameters)
  }
}
